module.exports = __webpack_public_path__ + "static/media/plus.12485f5b.svg";